/* eslint-disable max-len */
export const OTR_MICROWAVES_ANIMATIONS = {
  FOUR_EASY_STEPS: 'https://dam.thdstatic.com/content/production/HCH7BLdVbBDlRaSKb4669g/zFblzMgkby-QRMCgmsQRkg/Original%20file/d29a-major-appliance-delivery-ux--first-page-animation-1224.gif',
  DELIVERY_PATH: 'https://dam.thdstatic.com/content/production/OU7cv-OLJxUhl2KOlOlBRA/o4-DUvXgRLSUnrwzgcxOCw/Original%20file/Step-1-OTR-Microwave-Delivery-Path.gif',
  OTR_MICROWAVE_WIDTH: 'https://dam.thdstatic.com/content/production/t5MhVfxwRzpInfMh85Uwsg/otnW28vW691DVwZ3N2y0YQ/Original%20file/Step-2-OTR-Microwave-Width.gif',
  OTR_MICROWAVE_HEIGHT: 'https://dam.thdstatic.com/content/production/IYRQt2QqUC0YSs5UBUIjbA/mMncwe2WqNtp9Wtiln25aA/Original%20file/Step-3-OTR-Microwave-Height.gif',
  OTR_MICROWAVE_DEPTH: 'https://dam.thdstatic.com/content/production/iLvZE2zqF5bWJpfyUvxv_Q/rMyPjobBu0ykK1bCFdmMzw/Original%20file/Step-4a-OTR-Microwave-Depth.gif',
  OTR_MICROWAVE_DOORS_OPEN: 'https://dam.thdstatic.com/content/production/MiaRdOlrt5KJbIkOoDDDrw/y-ATXXFb5bhh7oAddLfEDA/Original%20file/Step-4b-OTR-Microwave-doors-open.gif'
};

export const OTR_MICROWAVES_DRAWER_MAPPING = [
  // Page 1
  {
    header: 'Make Sure It Fits',
    sections: [
      {
        text: {
          id: 'text_0',
          string: 'Let\'s Measure Your Space In Four Easy Steps',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_1',
          string: 'Accurate measurements will ensure a perfect fit for your new over-the-range microwave. You\'ll need a tape measure and be ready to take notes.'
        }
      },
      {
        image: {
          id: 'image_0',
          src: OTR_MICROWAVES_ANIMATIONS.FOUR_EASY_STEPS,
          alt: 'Four Easy Steps',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_0',
          strings: [
            'You\'re not measuring your old over-the-range microwave. Focus on the space it will be installed and clear a path for delivery.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_2',
          string: 'Need help measuring? Please call your local store for more information.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 2
  {
    header: 'Step 1 of 4',
    sections: [
      {
        text: {
          id: 'text_3',
          string: 'Map Your Delivery Path',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_4',
          string: 'We want delivery and installation to go easy for you.'
        }
      },
      {
        text: {
          id: 'text_5',
          string: 'Our experts suggest:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_0',
          items: [
            'Find a route with the least obstacles from the delivery truck to the installation location.',
            'Measure your front door, interior doors, hallways and tight spaces along this path.',
            'Take note of the narrowest gap and tight turns.'
          ]
        }
      },
      {
        image: {
          id: 'image_1',
          src: OTR_MICROWAVES_ANIMATIONS.DELIVERY_PATH,
          alt: 'OTR Microwave Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_6',
          string: 'This will help you know if your over-the-range microwave will clear the delivery path.'
        }
      },
      {
        tip: {
          id: 'tip_1',
          strings: [
            'Consider removing doors if necessary prior to the delivery. Be prepared to remove furniture, decor and rugs along the path on delivery day.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 3
  {
    header: 'Step 2 of 4',
    sections: [
      {
        text: {
          id: 'text_7',
          string: 'Measure the Width',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_8',
          string: 'In the space where your over-the-range microwave will go, take note of the width in two places:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_1',
          items: [
            'at the top of the cutout between cabinets',
            'at the bottom of the cutout between cabinets'
          ]
        }
      },
      {
        text: {
          id: 'text_9',
          string: 'Use the smallest measurement of the two.'
        }
      },
      {
        image: {
          id: 'image_2',
          src: OTR_MICROWAVES_ANIMATIONS.OTR_MICROWAVE_WIDTH,
          alt: 'Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_10',
          string: 'Standard over-the-range microwaves are around 30 inches wide.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 4
  {
    header: 'Step 3 of 4',
    sections: [
      {
        text: {
          id: 'text_11',
          string: 'Measure the Height',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_12',
          string: 'In the space where your over-the-range microwave  will go, take note of the height in two places:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_2',
          items: [
            'underside of left-side cabinet to top of cutout.',
            'underside of right-side cabinet to top of cutout.'
          ]
        }
      },
      {
        text: {
          id: 'text_13',
          string: 'Use the shorter of the two measurements for the overall height needed.'
        }
      },
      {
        text: {
          id: 'text_14',
          string: 'It may extend below the cabinets as long as there are 30 inches between the bottom of the microwave and the cooktop.'
        }
      },
      {
        image: {
          id: 'image_3',
          src: OTR_MICROWAVES_ANIMATIONS.OTR_MICROWAVE_HEIGHT,
          alt: 'OTR Microwave Measure Height',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_2',
          strings: [
            'For more space above your cooking surface, consider a low profile over-the-range microwave.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_15',
          string: 'Standard over-the-range microwaves are around 15-17 inches high. Low profile versions can be as little as 10" high.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // // Page 5
  {
    header: 'Step 4 of 4',
    sections: [
      {
        text: {
          id: 'text_16',
          string: 'Decide on Depth',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_17',
          string: 'Measure the depth from the back wall to the front of the adjacent cabinet, excluding the door.'
        }
      },
      {
        image: {
          id: 'image_4',
          src: OTR_MICROWAVES_ANIMATIONS.OTR_MICROWAVE_DEPTH,
          alt: 'OTR Microwave Measure Depth',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_18',
          string: 'Allow around 24 inches of space in front of your over-the-range microwave to fully open the door and easily insert or remove food.'
        }
      },
      {
        tip: {
          id: 'tip_3',
          strings: [
            'Make sure the over-the-range microwave supports your chosen venting method—internal or external. External ventilation is strongly recommended for gas stoves.'
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        image: {
          id: 'image_5',
          src: OTR_MICROWAVES_ANIMATIONS.OTR_MICROWAVE_DOORS_OPEN,
          alt: 'OTR Microwave Door Measure Depth Swing Gif',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_19',
          string: 'Standard over-the-range microwaves are around 15-16 inches deep.',
          isTiny: true
        }
      }
    ],
    footer: 'Done'
  }
];